import {createAsyncThunk} from "@reduxjs/toolkit";
import { getFamilyPurchaseHistory } from "../history/bitrixHistory";
import { fetchMyProfiles } from "../profileInfo/asyncActions";

import {IHalls} from "./types";

export const fetchHalls = createAsyncThunk<any[]>(
    "halls/fetchHalls",
    async (_, { getState, dispatch }) => {
        try {
            await dispatch(fetchMyProfiles()).unwrap();
            
            const state: any = getState();
            const myProfiles = state.getProfileInfo?.myProfiles || [];
            const partnerId = state.user?.partnerId;
            
            const partnerIds: string[] = [];
            const uniquePartnerIds = new Set<string>();
            
            if (partnerId) {
                uniquePartnerIds.add(String(partnerId));
            }
            
            myProfiles.forEach((profile: any) => {
                if (profile.partner_id) {
                    uniquePartnerIds.add(String(profile.partner_id));
                }
            });
            
            partnerIds.push(...Array.from(uniquePartnerIds));

            if (partnerIds.length === 0) {
                return [];
            }

            const historyData = await getFamilyPurchaseHistory(partnerIds);
            
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            
            const activeRents: any[] = [];
            
            if (historyData.rents && Array.isArray(historyData.rents)) {
                historyData.rents.forEach((rent: any) => {
                    const finishDate = new Date(rent.finishTime);
                    if (finishDate >= today) {
                        const startTime = new Date(rent.startTime);
                        const endTime = new Date(rent.finishTime);
                        
                        activeRents.push({
                            ...rent,
                            date: rent.startTime,
                            time: startTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                            time_to: endTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }),
                            hall: {
                                title: `Корт`,
                                id: rent.courtId,
                            },
                            hall_id: rent.courtId,
                            price: rent.rentSum || 0,
                            checked: 1,
                            paid: 1,
                        });
                    }
                });
            }
            
            return activeRents;
        } catch (error) {
            throw error;
        }
    }
);
